import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { MouseLeft, MouseRight } from './icons.js';
import { faAngleUp, faArrowRightToBracket, faArrowTurnDown, faCaretDown, faCaretLeft, faCaretRight, faCaretUp, faDeleteLeft, } from '@fortawesome/free-solid-svg-icons';
import { FAIcon } from './styled.js';
export const MappedKeyDisplay = {
    KeyA: 'A',
    KeyB: 'B',
    KeyC: 'C',
    KeyD: 'D',
    KeyE: 'E',
    KeyF: 'F',
    KeyG: 'G',
    KeyH: 'H',
    KeyI: 'I',
    KeyJ: 'J',
    KeyK: 'K',
    KeyL: 'L',
    KeyM: 'M',
    KeyN: 'N',
    KeyO: 'O',
    KeyP: 'P',
    KeyQ: 'Q',
    KeyR: 'R',
    KeyS: 'S',
    KeyT: 'T',
    KeyU: 'U',
    KeyV: 'V',
    KeyW: 'W',
    KeyX: 'X',
    KeyY: 'Y',
    KeyZ: 'Z',
    Digit0: '0',
    Digit1: '1',
    Digit2: '2',
    Digit3: '3',
    Digit4: '4',
    Digit5: '5',
    Digit6: '6',
    Digit7: '7',
    Digit8: '8',
    Digit9: '9',
    Tab: _jsx(FAIcon, { icon: faArrowRightToBracket }),
    Backspace: _jsx(FAIcon, { icon: faDeleteLeft }),
    Enter: (_jsx(FAIcon, { style: {
            transform: 'rotate(90deg)',
        }, icon: faArrowTurnDown })),
    ShiftLeft: _jsx(FAIcon, { icon: faAngleUp }),
    ShiftRight: _jsx(FAIcon, { icon: faAngleUp }),
    Space: ' ',
    ArrowUp: _jsx(FAIcon, { icon: faCaretUp }),
    ArrowDown: _jsx(FAIcon, { icon: faCaretDown }),
    ArrowLeft: _jsx(FAIcon, { icon: faCaretLeft }),
    ArrowRight: _jsx(FAIcon, { icon: faCaretRight }),
    Semicolon: ';',
    Equal: '=',
    Comma: ',',
    Minus: '-',
    Period: '.',
    Slash: '/',
    Backquote: '`',
    BracketLeft: '[',
    Backslash: '\\',
    BracketRight: ']',
    Quote: "'",
    MouseLeft: _jsx(MouseLeft, {}),
    MouseRight: _jsx(MouseRight, {}),
};
//# sourceMappingURL=keys.js.map